export default "__VITE_ASSET__mDuq6ufg__"